export default "__VITE_ASSET__BQWWIKY0__"